const getPreviewVhost = (rootState) => rootState.ui.previewMode.previewVhost;

export default getPreviewVhost;
